import { render, staticRenderFns } from "./GStatisticsChart.vue?vue&type=template&id=20b9d12a&scoped=true&"
import script from "./GStatisticsChart.vue?vue&type=script&lang=ts&"
export * from "./GStatisticsChart.vue?vue&type=script&lang=ts&"
import style0 from "./GStatisticsChart.vue?vue&type=style&index=0&id=20b9d12a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b9d12a",
  null
  
)

export default component.exports